import { withState } from "./withState";
import { StatelessSearchInput } from "./StatelessSearchInput";
export { StatelessSearchInput } from "./StatelessSearchInput";

/** @deprecated Replaced by StatefulSearchInput (fully compatible) */
export var SearchInput = withState(StatelessSearchInput);
export var StatefulSearchInput = withState(StatelessSearchInput);